import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ResourceService } from 'src/app/global/services/resource.service';
import { WEB_API } from 'src/app/global/services/web-api';
import { Produto } from '../domain/produto.model';
import { Page } from '../domain/return-api.model';
import { ConciliacaoBancariaDoc } from '../domain/conciliacao-bancaria-doc.model';
import { ConciliacaoBancariaDocSerializer } from '../serializables/conciliacao-bancaria-doc.serializer';
import { ParcelaClienteDOCView } from '../domain/parcela-cliente-doc-view.model';
import { ParcelaChatbot } from '../domain/parcela-chatbot.model';
import { PesquisaMapa } from '../domain/pesquisa-mapa.model';
import { Estabelecimentos } from '../domain/estabelecimento.model';
@Injectable()
export class PesquisaMapaService {
  private static RESOURCE = 'pesquisa-mapa';
  private static ESTABELECIMENTO = 'estabelecimentos';

  produto: Produto;
  produtoId: string;

  constructor(private http: HttpClient) {
  }

  findAllPageable(queryOptions: QueryOptions): Observable<Page<PesquisaMapa>> {
    return this.http.get<Page<PesquisaMapa>>(`${WEB_API}/${PesquisaMapaService.RESOURCE}/pageable?${queryOptions.toQueryString()}`);
  }

//   associar(data: {}): Observable<any> {
//     return this.http.post<any>(`${WEB_API}/${PesquisaMapaService.RESOURCE}/associar`, data);
//   }

//   getValorTotal(queryOptions: QueryOptions): Observable<any> {
//     return this.http.get<number>(`${WEB_API}/${PesquisaMapaService.RESOURCE}/get-valor-total?${queryOptions.toQueryString()}`);
//   }

   createPesquisa(dto: any): Observable<PesquisaMapa> {
    return this.http.post<PesquisaMapa>(`${WEB_API}/${PesquisaMapaService.RESOURCE}/criar`, dto);
   }
   createEstabelecimento(dto: any): Observable<Estabelecimentos> {
    return this.http.post<Estabelecimentos>(`${WEB_API}/${PesquisaMapaService.ESTABELECIMENTO}/criar-estabelecimento`, dto);
   }
}
